import {ErrorHandler} from '../../modules/error_handler';
import LanguageManager from '../../modules/language_manager/language_manager';
import ObjectUtils from "../../util/object_utils";

let Browser = {};

Browser.OPERA = 'opera';
Browser.EDGE = 'edge';
Browser.BLINK = 'blink';
Browser.SAFARI = 'safari';
Browser.FIREFOX = 'firefox';
Browser.IE = 'ie';
Browser.CHROME = 'chrome';
Browser.OTHER = 'other';

Browser.ALLOWED_BROWSERS = [
    Browser.OPERA,
    Browser.EDGE,
    Browser.BLINK,
    Browser.SAFARI,
    Browser.FIREFOX,
    Browser.IE,
    Browser.CHROME,
    Browser.OTHER
];

/**
 * Returns the browser of the client. Returns 'other' if cannot be selected.
 * @return {{version: {string}, name: {string}}
 */

Browser.currentBrowser = function() {
    const ua = navigator.userAgent;
    let M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    let tem;
    if (/trident/i.test(M[1])) {
        M[0] = 'ie';
    } else {
        if (M[1] === 'Chrome') {
            tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
            if (tem != null) return tem.slice(1)[0].toLowerCase().replace('opr', 'opera'); // todo: test opera
        }
        M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
        if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    }
    M[0] = M[0].toLowerCase();
    if (M[0].indexOf('ie') > -1) M[0] = 'ie';
    if (M[0].indexOf('edge') > -1) M[0] = 'edge';
    // Todo: move logic to different function to throw error
    if (Browser.ALLOWED_BROWSERS.indexOf(M[0]) > -1) return {name: M[0], version: M[1]};
    else ErrorHandler.throwError({console: 'Browser ' + M[0] + ' is not supported at this moment'});
};

/**
 * Returns the device type of the client. Returns 'other' if cannot be selected.
 */
Browser.getDeviceType = function() {
    var ua = navigator.userAgent.toLowerCase(),
        devicesType = {
            labels: ['Android', 'iPhone', 'iPad', 'iPod', 'Playstation', 'PC( Windows )', 'PC( MAC )', 'PC (Linux)'],
            keys: ['android', 'iphone', 'ipad', 'ipod', 'playstation', 'win', 'mac', 'linux']
        };
    if (ua.match(/samsung|sgh-[i|n|t]|gt-[i|p|n]|sm-[n|p|t|z|g]|shv-e|sch-[i|j|r|s]|sph-l/i) !== null) {
        return 'Samsung';
    } else {
        for (var i = 0; i < devicesType.keys.length; i++) {
            if (ua.indexOf(devicesType.keys[i]) > -1) return devicesType.labels[i];
        }
    }
    return 'Other';
};

/**
 * Returns the device manufacturer of the client. Returns 'other' if cannot be selected.
 */
Browser.getManufacturer = function() {
    return navigator.platform || 'Other';
};

/**
 *
 * @param videoType
 * @param [options={}]
 * @param options.browser
 * @param options.trailer
 * @return {{flash, dash, hls}}
 */
Browser.getSupportedAssetTypes = function(videoType, options) {
    options = options || {};
    var browser = options.browser || Browser.currentBrowser().name;

    if (options.trailer) {
        return getSupportedTrailerAssetTypes(videoType);
    } else if (videoType === 'movies') {
        return getSupportedMovieAssetTypes(browser);

    } else if (videoType === 'series') {
        return getSupportedMovieAssetTypes(browser);
    } else {
        ErrorHandler.throwError({
            message: LanguageManager.get('error_571101_no_asset_type')
        }, {
            reason: 'Couldnt find asset type for videoType.',
            given: videoType
        });
    }
};

Browser.attachAssetTypesFilterParamsToUri = function(uri, options) {
    let assetTypesList = ObjectUtils.values(getAssetTypesToRequest(options.videoType, {trailer: options.trailer}));
    assetTypesList.push('filmstrip_199x110');
    let paramsStartingCharacter = uri.indexOf('?') === -1 ? '?' : '&';
    uri += paramsStartingCharacter + 'mediaAssetTypes=' + assetTypesList.join(',');
    return uri;
};

function getAssetTypesToRequest(videoType, options) {
    let type = {};
    let browser = Browser.currentBrowser().name;

    if (options.trailer) {
        return getSupportedTrailerAssetTypesToRequest(videoType);
    } else {
        switch (browser) {
            case Browser.CHROME:
            case Browser.FIREFOX:
                type['dash'] = ['dash_widevine_spa'];
                break;
            case Browser.IE:
            case Browser.EDGE:
                type['dash'] = ['dash_playready_spa'];
                break;
            case Browser.SAFARI:
                type['hls'] = ['hls_fairplay_spa'];
                break;
            case Browser.OPERA:
            case Browser.BLINK:
                type['dash'] = ['dash_playready_spa'];
                break;
            default:
                type['dash'] = ['dash_widevine_spa'];
                type['hls'] = ['hls_fairplay_spa'];
        }
    }

    return type;
}

function getSupportedTrailerAssetTypesToRequest(videoType) {
    let type = videoType === 'movies' ? 'movie' : 'series';
    return {
        dash: ['dash_t01_' + type + '_spa'],
        hls: ['hls_t01_' + type + '_spa']
    };
}

function getSupportedTrailerAssetTypes(videoType) {
    let type = videoType === 'movies' ? 'movie' : 'series';
    return {
        dash: ['dash_t01_' + type + '_spa', 'dash_t01_' + type + '_vu'],
        hls: ['hls_t01_' + type + '_spa', 'hls_t01_' + type + '_vu']
    };
}

function getSupportedMovieAssetTypes(browser) {
    let type = {};
    switch (browser) {
        case Browser.CHROME:
            type['dash'] = ['dash_widevine_vu', 'dash_widevine_spa'];
            break;
        case Browser.IE:
            type['dash'] = ['dash_playready_vu', 'dash_playready_spa'];
            break;
        case Browser.EDGE:
            type['dash'] = ['dash_playready_vu', 'dash_playready_spa'];
            break;
        case Browser.SAFARI:
            type['hls'] = ['hls_fairplay_vu', 'hls_fairplay_spa'];
            break;
        case Browser.FIREFOX:
            type['dash'] = ['dash_widevine_vu', 'dash_widevine_spa'];
            break;
        case Browser.OPERA:
            type['dash'] = ['dash_playready_vu', 'dash_playready_spa'];
            break;
        case Browser.BLINK:
            type['dash'] = ['dash_playready_vu', 'dash_playready_spa'];
            break;
        default:
            type['dash'] = ['dash_widevine_vu', 'dash_widevine_spa'];
            type['hls'] = ['hls_fairplay_vu', 'hls_fairplay_spa'];
    }

    return type;
}

module.exports = Browser;



// WEBPACK FOOTER //
// ./src/modules/browser/browser.js